<template>
  <div class="searchPackageBox">
    <div class="searchPackage">
      <!-- 筛选 -->
      <div class="searchPackage-filter" ref="searchPackageFilter">
        <div class="filter-container js-openFilterModel">
          <div
            class="filter-item"
            :class="{
              selected: checkFilterSelected(['sailDates']),
              active: showFilterCategory == 'sailDates',
            }"
            @click="openFilterCategory('sailDates')"
          >
            <span
              class="filter-itemTitle"
              >出发时间</span
            >
<!--            <span-->
<!--              class="filter-itemTitle"-->
<!--              v-if="checkFilterSelected(['sailDates'])"-->
<!--              >{{ getFilterSelectedName(["sailDates"]) }}</span-->
<!--            >-->
            <div class="filter-itemArrow">
              <img v-if="showFilterCategory == 'sailDates'"
                   src="../../assets/arrows-blue.png"
                   alt="向下箭头"
              />
              <img v-else
                   src="../../assets/arrows-bot.png"
                   alt="向上箭头"
              />
            </div>

          </div>
          <div
              class="filter-item"
              :class="{
              selected: checkFilterSelected(['departures']),
              active: showFilterCategory == 'departures',
            }"
              @click="openFilterCategory('departures')"
          >
            <span
                class="filter-itemTitle"
            >出发港口</span
            >
            <div class="filter-itemArrow">
              <img v-if="showFilterCategory == 'departures'"
                  src="../../assets/arrows-blue.png"
                  alt="向下箭头"
              />
              <img v-else
                  src="../../assets/arrows-bot.png"
                  alt="向上箭头"
              />
            </div>

          </div>
          <div
            class="filter-item"
            :class="{ active: showFilterCategory == 'orderBy' }"
            @click="openFilterCategory('orderBy')"
          >
            <span class="filter-itemTitle" v-html="getOrderByName()"></span>
            <div class="filter-itemArrow" v-if="getOrderByName()==='综合排序'">
              <img  style="width: 12px;height: 12px" v-if="showFilterCategory == 'orderBy'"
                   src="https://resource.rcclchina.com.cn/mobileSearchPackage/sortActive.png"
                   alt="向下箭头"
              />
              <img style="width: 12px;height: 12px" v-else
                   src="https://resource.rcclchina.com.cn/mobileSearchPackage/synthesis-icon.png"
                   alt="向上箭头"
              />
            </div>
          </div>
          <div
            class="filter-item"
            :class="{
              selected: checkFilterSelected([
                'destinations',
                'sailDays',
                'tags',
                'shipCodes',
              ]),
              active: showFilterCategory == 'others',
            }"
            @click="openFilterCategory('others')"
          >
            <div class="filter-itemTitle">
              <span >更多筛选</span>
<!--              <img v-if="showFilterCategory === 'others'" src="../../assets/filter-blueIcon.png"  alt="">-->
<!--              <img v-else src="../../assets/filter-icon.png" alt="">-->
            </div>
            <div class="filter-itemArrow">
              <img style="width: 15px;height: 12px" v-if="showFilterCategory == 'others'"
                src="https://resource.rcclchina.com.cn/mobileSearchPackage/moreActiveIcon.png"
              />
              <img style="display: inline-block;width: 15px;height: 12px"  v-else
                src="https://resource.rcclchina.com.cn/mobileSearchPackage/moreIcon.png"
              />
            </div>

          </div>
        </div>
      </div>

      <!-- tag -->
      <div class="searchPackage-tags" ref="searchPackageTags">
        <!-- @* 标签 *@ -->
        <div class="tags-container" v-if="topSearchs.length >0">
          <div class="swiper-container tagsSwiper">
            <div class="swiper-wrapper" style="height: auto;overflow: auto;">
              <div
                class="swiper-slide"
                v-for="(topSearch, i) in topSearchs"
                :key="i"
              >
                <div
                  :class="{active:isLabelActive(topSearch.tagType)}"
                  class="tags-item js-filterConditionBtn"
                  @click="onKeywordSelected(topSearch.tagType)"
                >
                  {{ topSearch.tagType }}
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev" style="display: none">
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/leftIcon.png"
            />
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/leftIcon.png"
            />
          </div>
          <div class="swiper-button-next" style="display: none">
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/rightIcon.png"
            />
            <img
              src="https://resource.rcclchina.com.cn/mobileSearchPackage/rightIcon.png"
            />
          </div>
        </div>
      </div>
      <div ref="filterMoreSelect" class="filterMoreSelectBox" v-if="selectFilterCodesView.length>0">
        <div  class="content" :style="{height: isPackUpIcon?'15px':''}">
          <div class="contentItem" v-for="(filter, i) in selectFilterCodesView" :key="i" @click="onFilterRemove(filter.code, filter.key, filter.name)">
            <div class="text">{{filter.key == 'departures' ? '出发港:': ''}} <span class="text-icon" v-html="filter.name||filter.code"></span> </div>
            <img class="icon" :src="`${imgUrl}/mobileSearchPackage/icon-closed-grey.png`" alt=""/>
          </div>
          <div class="contentItem emptyCondition" @click="onResetClick()">
            <div class="text"><span class="text-icon">清空条件</span> </div>
          </div>
        </div>
        <div class="downward" v-if="selectFilterCodesView.length>=4" @click="bindSearch">
          <img v-if="isPackUpIcon" src="../../assets/downward.png" alt="">
          <img v-else src="../../assets/packup.png" alt="">
        </div>
      </div>

      <!-- 列表 -->
      <div
        ref="searchPackageLists"
        class="searchPackage-lists scroll-container js-smartScroll"
        @scroll.passive="checkShowScroll"
      >
        <div ref="searchListContent" class="searchPackage-listsCon">
          <div class="filterBanner" v-if="filterBannerList.length>0">
            <Swiper
                ref="bannerSwiper"
                :options="swiperOptions"
                class="swiper-container swiper-topics topics"
            >
              <SwiperSlide
                  v-for="(item, i) in filterBannerList"
                  :key="i"
                  class="swiper-slide promoBannerLink external"
              >
                <img :src="item.image" @click="handleFilterBanner(item.link, i)" alt=""/>
              </SwiperSlide>
              <div
                  ref="swiper-pagination"
                  class="swiper-pagination"
                  v-if="filterBannerList.length>1"
                  slot="pagination"
              ></div>
            </Swiper>
          </div>
          <div class="initiation"
                       v-if="(userPoint.userIdentity===0&& !isOverseaUser) || !userToken" @click="handleAddVip">
            <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/bannerLinkPic.png" alt="">
          </div>
          <SearchCruiseItem
            v-for="(cruise, i) in cruiseLists"
            :key="i"
            :cruise="cruise"
          />
        </div>
        <!-- <infinite-loading
                    slot="append"
                    :identifier="loadingId"
                    force-use-infinite-wrapper=".searchPackage-lists"
                    @infinite="infiniteHandler">

                    <div slot="no-more"></div>
                    <div slot="no-results"></div>

                </infinite-loading>
             -->

        <div v-if="cruiseLists.length === 0" class="infinite-scroll-preloader">
<!--          <span class="no-more-text" :class="{ dn: cruiseLists.length > 0 }">尚无筛选结果，请重新选择</span>-->
          <span class="no-more-text">航线计划中，敬请期待</span>
        </div>

<!--        <div v-if="isLoadingCruise && cruiseLists.length === 0" class="infinite-scroll-preloader">-->
<!--          <span class="no-more-text" :class="{ dn: cruiseLists.length > 0 }">尚无筛选结果，请重新选择</span>-->
<!--        </div>-->
<!--        <div v-else class="infinite-scroll-preloader">-->
<!--          <span class="no-more-text">航线计划中，敬请期待</span>-->
<!--        </div>-->
      </div>

      <!-- 筛选内容 -->
      <SearchFilter
        :cruiseFilters="cruiseFilters"
        :initSelectFilterCodes="selectFilterCodes"
        :showFilterCategory="showFilterCategory"
        :months="months"
        :shipCodes="shipCodes"
        :departures="departures"
        :destinations="destinations"
        :tags="tags"
        :tagFilters="tagFilters"
        :tagPromoList="tagPromoList"
        :themeList="themeList"
        :tagHolidayList="tagHolidayList"
        :filterConfirmHandler="filterConfirmHandler"
        :emptyCondition="emptyCondition"
      />
    </div>

    <!-- 船票包含 -->
    <div
        ref="ticketIcon"
        class="searchPackage-priceIcon js-ticketTips js-rightBarBtn"
        @click="showTicketContainsPopup()"
    >
      船票<br />包含
    </div>
    <!-- 费用说明 -->
    <div
      ref="priceIcon"
      class="searchPackage-priceIcon js-priceTips js-rightBarBtn"
      @click="showCruisePriceInfo()"
    >
      价格<br />说明
    </div>
    <!-- 滚动到顶部 -->
    <div
      ref="toScrollTop"
      class="searchPackage-scrollTop js-scrollTopBtn js-rightBarBtn"
      @click="scrollToTop()"
    >
      <img
        src="https://resource.rcclchina.com.cn/mobileSearchPackage/scrollTopIcon.png"
      />
    </div>

    <div
      ref="popupIcon"
      class="cruiseFixCon-promoBtn js-rightBarBtn"
      v-show="mobilePopupImage && mobilePopupImage.id > 0 && !isShowPopup"
    >
      <a class="external" :href="mobilePopupImage.link" target="_blank" @click="goPromoPage(mobilePopupImage.link)">
        <img :src="mobilePopupImage.iconImage" />
      </a>
    </div>

    <div
      ref="popupPromo"
      class="promo-popuop cruise-search-promo-popup"
      v-show="mobilePopupImage && mobilePopupImage.id > 0 && isShowPopup"
    >
      <div class="promo-wrapper">
        <div class="promo-popup-close" @click="closePopup()">
          <img
            src="https://resource.rcclchina.com.cn/cruiseSearch/popup/popup_close.png"
          />
        </div>
        <div class="promo-popup-content">
          <a :href="mobilePopupImage.link" class="external" target="_blank" @click="goPromoPage(mobilePopupImage.link)">
            <img
              style="width: 91%; margin: auto; display: block"
              :src="mobilePopupImage.imageUrl"
            />
          </a>
        </div>
      </div>
    </div>

    <TicketContainsPopup :tags="tags"
                         :isShow="isShowTicketContainsPopup"
                         :onGoBack="closeTicketContainsPopup"></TicketContainsPopup>

    <CruisePriceInfo
      :onGoBack="closeCruisePriceInfo"
      :isShow="isShowCruisePriceInfoPopup"
    />

    <EmergencyMessageAlert />
<!--    v-if="cruiseCategories.length > 0 && promoCruiseItems.length > 0"-->
    <LikeRoutePopups v-if="likeRoutePopupsList.length>0" :likeRoutePopupsList="likeRoutePopupsList"></LikeRoutePopups>
    <!-- <div class="wn-baby-right wn-baby-image" v-if="showPromo===1" id="wnBabyRight" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/mb-3.gif"/>
    </div> -->
  </div>
</template>

<script>
const SearchFilter = () => import("@/components/Cruise/SearchFilter");
const SearchCruiseItem = () => import("@/components/Cruise/SearchCruiseItem");
const CruisePriceInfo = () => import("@/components/Cruise/CruisePriceInfo");
const EmergencyMessageAlert = () => import("@/components/Home/EmergencyMessageAlert");
const TicketContainsPopup = () => import("@/components/Cruise/TicketContainsPopup");
const LikeRoutePopups = () => import("@/components/Home/LikeRoutePopups")
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import {getRandomInt, gioAdsTracking, gioTracking, isEmpty} from "@/utilities/tools";
import "swiper/css/swiper.css";
import _ from "lodash";
import api from "@/api";

const promoCountDown = 8 * 1000;
const randomPromoOff = 1 * 1000;
const randomPromoShow = 6 * 1000 + randomPromoOff;

export default {
  name: "CruiseSearch",
  components: {
    Swiper,
    SwiperSlide,
    SearchFilter,
    SearchCruiseItem,
    // InfiniteLoading,
    CruisePriceInfo,
    EmergencyMessageAlert,
    TicketContainsPopup,
    LikeRoutePopups
  },
  directives: {
    swiper: directive,
  },
  scrollEndTimeout: null,
  asyncData({ store }) {
    return new Promise((resolve, reject) => {
      return (
        api.cruise
          .getCruiseSearchPage()
          // .then(()=> {
          //     return component.initPage()
          // })
          .then(({ success, data, errMsg }) => {
            if (!success) console.error(errMsg);
            store.commit("SET_CRUISE_SEARCH_PAGE", { data });
            if (data.seoViewModel) {
              store.commit("SET_META", data.seoViewModel);
            }
            resolve();
          })
          .catch((e) => {
            reject(e);
          })
      );
    });
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      tagsSwiperOption: {},
      selectFilterCodes: {
        departures: [],
        destinations: [],
        sailDates: [],
        sailDays: [],
        shipCodes: [],
        tags: [],
        keywords: [],
        orderBysailDate: 0,
        orderByPrice: 0,
        orderBySailDays: 0,
        orderByAmountPerNight: 0,
      },
      queryString: {},
      showFilterCategory: "",
      initQueryString: "",
      offset: 0,
      limit: 10,
      cruiseLists: [],
      loadingId: 0,
      isLoadingCruise: false,
      isShowCruisePriceInfoPopup: false,
      isShowPopup: false,
      isFirstLoading: true,
      showPromo: -1,
      checkPromoTimeout: null,
      isShowTicketContainsPopup: false,
      tikTokCode: null,
      likeRoutePopupsList:[],
      selectFilterCodesView:[],
      emptyCondition:true,
      filterBannerList:[],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        loop: false,
        autoplay: {
          delay: 5000,
        },
      },
      userPoint:{},
      userToken:'',
      isPackUpIcon:true,
      selectHeight:'',
      lastScrollTop:0
    };
  },
  mounted() {
    this.resizeCruiseList();
  },
  created() {
    if(!isEmpty(this.$route.query.tikTokCode)) {
      sessionStorage.setItem('tikTokCode', this.$route.query.tikTokCode)
    }
  },
  activated() {
    this.$store.commit("SET_PAGE_TITLE", "中国出发航线");
    const self = this;
    window.onpopstate = () => {
      if (self.isShowCruisePriceInfoPopup) {
        self.closeCruisePriceInfo();
      }
    };
    this.$refs.searchPackageLists.addEventListener(
      "scroll",
      this.cruiseListScrollHandler
    );

    // 当init query string不同时，说明url参数有变化，需要重新刷新页面
    if (
      this.initQueryString != JSON.stringify(this.$route.query) &&
      !this.isFirstLoading
    ) {
      return this.initPage();
    }
    // 检查弹窗
    this.checkPopup();
		this.pageTrack();
    // if (this.showPromo < 0) {
    //   this.showPromoTimeout();
    // }
    this.getSearchYouLikeRoute()
  },
  deactivated() {
    window.onpopstate = () => {};
    this.$refs.searchPackageLists.removeEventListener(
      "scroll",
      this.cruiseListScrollHandler
    );
    this.showPromo = -1;
    if (this.checkPromoTimeout) {
			clearTimeout(this.checkPromoTimeout);
		}
    if (this.promoEffectInterval) {
      clearInterval(this.promoEffectInterval)
    }
  },
  methods: {
    initPage() {
      // 根据query参数设定cruise filter
      const query = this.$route.query;
      let filterRequests = [];
      let filters = {
        departures: [],
        destinations: [],
        sailDates: [],
        sailDays: [],
        shipCodes: [],
        tags: [],
        keywords: [],
        orderBysailDate: 0,
        orderByPrice: 0,
        orderBySailDays: 0,
        orderByAmountPerNight: 0,
      };
      if (query.sailDates) {
        query.sailDates.split(",").forEach((item) => {
          filterRequests.push({ key: "sailDates", values: [{ code: item }] });
          let date = item.replace("-",'年')+'月';
          // name最后添加一个月字
          filters.sailDates.push({ code: item, name: date ,type:'holidaySailDays'});
        });
      }
      if (query.destinationCodes) {
        query.destinationCodes.split(",").forEach((item) => {
          // 解决例如冲绳那样会有多个code的问题
          const filter = this.cruiseFilters.find(
            (r) => r.filterCode && r.filterCode.indexOf(item) >= 0
          );
          if (
            filter &&
            !filters.destinations.some((r) => r.code == filter.filterCode)
          ) {
            filterRequests.push({
              key: "destinations",
              values: [{ code: filter.filterCode }],
            });
            filters.destinations.push({ code: filter.filterCode,type:'destinations' });
          }
        });
      }
      if (query.departureCodes) {
        query.departureCodes.split(",").forEach((item) => {
          filterRequests.push({ key: "departures", values: [{ code: item }] });
          let data = { code: item,type:'departures' };

          const cruieFilter = this.cruiseFilters.filter(
            (r) => r.filterCode == item
          );
          if (cruieFilter && cruieFilter.length > 0) {
            data.name = cruieFilter[0].title;
          }
          filters.departures.push(data);
        });
      }
      if (query.shipCodes) {
        query.shipCodes.split(",").forEach((item) => {
          filterRequests.push({ key: "shipCodes", values: [{ code: item }] });
          filters.shipCodes.push({ code: item,type: 'shipCodes'});
        });
      }
      if (query.sailDays) {
        query.sailDays.split(",").forEach((item) => {
          const sailDay = parseInt(item);
          if (!isNaN(sailDay)) {
            filterRequests.push({
              key: "sailDays",
              values: [{ code: sailDay }],
            });
            filters.sailDays.push({ code: sailDay,type:'holidaySailDays' });
          }
        });
      }
      if (query.tags) {
        query.tags.split(",").forEach((item) => {
          item = decodeURIComponent(item);
          filterRequests.push({ key: "tags", values: [{ code: item }] });
          filters.tags.push({ code: item,type:'tagPromos'});
        });
      }
      if (query.keywords && query.keywords.length > 0) {
        query.keywords.split(",").forEach((item) => {
          item = decodeURIComponent(item);
          filterRequests.push({ key: "keywords", values: [{ code: item }] });
          filters.keywords.push({ code: item,type:'keywords'});
        });
      }
      if (query.orderBysailDate && query.orderBysailDate > 0) {
        filters.orderBysailDate = query.orderBysailDate;
        filters.orderBySailDays = 0;
        filters.orderByPrice = 0;
        filters.orderByAmountPerNight = 0;
      }
      if (query.orderByPrice && query.orderByPrice > 0) {
        filters.orderByPrice = query.orderByPrice;
        filters.orderBysailDate = 0;
        filters.orderBySailDays = 0;
        filters.orderByAmountPerNight = 0;
      }
      if (query.orderBySailDays && query.orderBySailDays > 0) {
        filters.orderBySailDays = query.orderBySailDays;
        filters.orderByPrice = 0;
        filters.orderBysailDate = 0;
        filters.orderByAmountPerNight = 0;
      }
      if (query.orderByAmountPerNight && query.orderByAmountPerNight > 0) {
        filters.orderByAmountPerNight = query.orderByAmountPerNight;
        filters.orderBySailDays = 0;
        filters.orderByPrice = 0;
        filters.orderBysailDate = 0;
      }
      this.$store.dispatch("INIT_CRUISE_FILTER_LIST", {
        cruiseType: "hp",
        data: filterRequests,
      });
      this.selectFilterCodes = filters;
      console.log(this.selectFilterCodes)
      this.selectFilterCodesView = this.initFilterData(this.selectFilterCodes);
      console.log(this.selectFilterCodesView)
      this.offset = 0;
      this.cruiseLists = [];
      this.initQueryString = JSON.stringify(query);
      this.userPoint = this.$store.state.user.userInfo;
      this.userToken = this.$store.state.user.userToken;
      this.getCruiseBanner()
      return this.cruiseSearch();
    },
    getSelectFilterCodesView() {
      return this.selectFilterCodesView.filter(r=>r.name && r.name.length > 0)
    },
    // 初始化选中的条件
    initFilterData (initFilters) {
      let filters = []
      Object.keys(initFilters).forEach((key) => {
        if(key!=='keywords'){
          if (key.indexOf("orderBy") >= 0) {
            // filters.push({ code: initFilters[key], name: this.getOrderByName(key, initFilters[key]), key: key})
          } else if (initFilters[key].length > 0) {
            initFilters[key].forEach((item) => {
              if (item.code && item.code.length > 0  || key == 'sailDays') {
                let name = item.name + ''
                if (!item.name) {
                  if (key == 'sailDays') {
                    if (item.code == 4) name = "4晚"
                    else if (item.code == 3) name = "3晚及以下"
                    else if (item.code == 5) name = "5晚"
                    else if (item.code > 5) name = "6晚及以上"
                  } else {
                    name = this.getFilterName(item.code)
                  }
                }
                filters.push({ code: item.code, name: name, key: key,type:item.type})
              }
            })
          }
        }
      })
      return filters
    },
    getFilterName (code) {
      const items = this.cruiseFilters.filter(r=>r.filterCode == code)
      return items.length > 0 ? items[0].title : ""
    },
		pageTrack () {
			//gioTracking("track", "CruiseDetail");
			// old tracking
			const hmsr = this.$store.state.page.trackingCode.hmsr || "";
			if (hmsr.length > 0) {
				gioTracking("track", "BF00_SearchPage", { hmsr: hmsr });
			}
		},
    getTopSearchClass(topSearch) {
      let classData = {};
      classData["active"] = this.selectFilterCodes.keywords == topSearch;
      const tags = this.$store.state.cruise.cruiseSearchPage.tags || [];
      var isHighShows = tags
        .filter((p) => p.tagType == topSearch)
        .map((p) => p.isHighShow);
      if (!isHighShows || isHighShows.length == 0) {
        return classData;
      }
      classData["isHighShow"] = isHighShows[0] == true;
      return classData;
    },
    getFilterSelectedName(types) {
      let selectedNames = [];
      types.forEach((type) => {
        if (this.selectFilterCodes[type].length > 0) {
          selectedNames.push(
            this.selectFilterCodes[type].map((r) => r.name).join(",")
          );
        }
      });
      return selectedNames.join(",");
    },
    getOrderByName() {
      if (this.selectFilterCodes.orderBysailDate == 1) {
        return `出发时间:近<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png" />远`;
      } else if (this.selectFilterCodes.orderBysailDate == 2) {
        return `出发时间:远<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png" />近`;
      } else if (this.selectFilterCodes.orderByPrice == 2) {
        return `人均起价:低<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png" />高`;
      } else if (this.selectFilterCodes.orderByPrice == 1) {
        return `人均起价:高<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png" />低`;
      } else if (this.selectFilterCodes.orderByAmountPerNight == 2) {
        return `人均每晚起价:低<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png" />高`;
      } else if (this.selectFilterCodes.orderByAmountPerNight == 1) {
        return `人均每晚起价:高<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png" />低`;
      } else if (this.selectFilterCodes.orderBySailDays == 2) {
        return `航程晚数:多<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortDes.png" />少`;
      } else if (this.selectFilterCodes.orderBySailDays == 1) {
        return `航程晚数:少<img src="https://resource.rcclchina.com.cn/mobileSearchPackage/filterSortAsc.png" />多`;
      }
      return `综合排序`
    },
    checkFilterSelected(types) {
      for (let i = 0; i < types.length; i++) {
        const type = types[i];
        if (this.selectFilterCodes[type].length > 0) {
          return true;
        }
      }
      return false;
    },
    onKeywordSelected(keywords) {
      console.log(this.selectFilterCodes.keywords)
      // 查找 keywords 是否已存在于数组中
      const index = this.selectFilterCodes.keywords.findIndex(item => item.code === keywords);
      if (index !== -1) {
        // 如果找到了，删除它
        this.selectFilterCodes.keywords.splice(index, 1);
      } else {
        // 如果没找到，添加新的元素
        this.selectFilterCodes.keywords.push({ name: keywords, key: 'keywords', code: keywords });
      }
      this.offset = 0;
      this.cruiseLists = [];
      this.cruiseSearch();
      this.replaceUrl();
    },
    isLabelActive(name){
      // 判断是否选中
      return this.selectFilterCodes.keywords.filter((r) => r.code == name).length > 0
    },
    openFilterCategory(category) {
      this.showFilterCategory = this.showFilterCategory == category ? "" : category;
    },
    filterConfirmHandler(filterCodes) {
      // this.initPage()
      this.showFilterCategory = "";
      const orderBySailDate = filterCodes.filter(
        (r) => r.key == "orderBysailDate"
      );
      const orderByPrice = filterCodes.filter((r) => r.key == "orderByPrice");
      const orderBySailDays = filterCodes.filter(
        (r) => r.key == "orderBySailDays"
      );
      const orderByAmountPerNight = filterCodes.filter(
        (r) => r.key == "orderByAmountPerNight"
      );
      // console.log('filterCodes',filterCodes)
      this.selectFilterCodes = {
        departures: filterCodes.filter((r) => r.key == "departures"),
        destinations: filterCodes.filter((r) => r.key == "destinations"),
        sailDates: filterCodes.filter((r) => { if(r.key == "sailDates") { r.isSubmit=true; return r } }),
        sailDays: filterCodes.filter((r) => r.key == "sailDays"),
        shipCodes: filterCodes.filter((r) => r.key == "shipCodes"),
        tags: filterCodes.filter((r) => r.key == "tags"),
        keywords: this.selectFilterCodes.keywords.filter((r) => r.key == "keywords"),
        orderBysailDate:
          orderBySailDate && orderBySailDate.length > 0
            ? orderBySailDate[0].code
            : 0,
        orderByPrice:
          orderByPrice && orderByPrice.length > 0 ? orderByPrice[0].code : 0,
        orderBySailDays:
          orderBySailDays && orderBySailDays.length > 0
            ? orderBySailDays[0].code
            : 0,
        orderByAmountPerNight:
          orderByAmountPerNight && orderByAmountPerNight.length > 0
            ? orderByAmountPerNight[0].code
            : 0,
      };
      this.offset = 0;
      this.cruiseLists = [];
      this.cruiseSearch();
      this.replaceUrl();
      this.selectFilterCodesView = this.initFilterData(this.selectFilterCodes);
      gioTracking('track', 'evt_Filter');
    },
    cruiseSearch() {
      const token = this.$store.state.user.userToken;
      let request = _.cloneDeep(this.selectFilterCodes);
      request.username = token;
      request.offset = this.offset;
      let tikTokCode = sessionStorage.getItem("tikTokCode");
      if(!isEmpty(tikTokCode)) {
        request.tikTokCode = tikTokCode;
      }
      let keywordsItme = ''
      this.selectFilterCodes.keywords.forEach((item,idx)=>{
        if(item.code){
          if(idx>0){
            keywordsItme += ","+item.code
          }else{
            keywordsItme += item.code
          }
        }
      })
      request.keywords = keywordsItme
      this.$loading.show();
      this.isLoadingCruise = true;
      return this.$store.dispatch("CRUISE_SEARCH", { data: request });
    },
    infiniteHandler($state) {
      if (this.cruiseLists.length == 0) {
        $state.loaded();
        $state.complete();
        return;
      } else if (this.cruiseLists.length >= this.storedCruiseCount) {
        $state.complete();
        return;
      }
      if (this.storedCruiseCount > this.cruiseLists.length) {
        this.offset += this.limit;
        this.cruiseSearch();
      }
    },
    replaceUrl() {
      // 根据搜索条件修改url参数
      let url = "/Rccl.Cruise/CruiseSearch/Search";
      let query = "";
      if (this.selectFilterCodes.departures.length > 0) {
        query +=
          "&departureCodes=" +
          this.selectFilterCodes.departures.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.shipCodes.length > 0) {
        query +=
          "&shipCodes=" +
          this.selectFilterCodes.shipCodes.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.sailDates.length > 0) {
        query +=
          "&sailDates=" +
          this.selectFilterCodes.sailDates.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.sailDays.length > 0) {
        query +=
          "&sailDays=" +
          this.selectFilterCodes.sailDays.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.destinations.length > 0) {
        query +=
          "&destinationCodes=" +
          this.selectFilterCodes.destinations.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.tags.length > 0) {
        query +=
          "&tags=" + this.selectFilterCodes.tags.map((r) => r.code).join(",");
      }
      if (this.selectFilterCodes.orderBysailDate > 0) {
        query += "&orderBysailDate=" + this.selectFilterCodes.orderBysailDate;
      }
      if (this.selectFilterCodes.orderByPrice > 0) {
        query += "&orderByPrice=" + this.selectFilterCodes.orderByPrice;
      }
      if (this.selectFilterCodes.orderBySailDays > 0) {
        query += "&orderBySailDays=" + this.selectFilterCodes.orderBySailDays;
      }
      if (this.selectFilterCodes.orderByAmountPerNight > 0) {
        query +=
          "&orderByAmountPerNight=" +
          this.selectFilterCodes.orderByAmountPerNight;
      }
      if (this.selectFilterCodes.keywords.length > 0) {
        query += "&keywords=" + this.selectFilterCodes.keywords.map((r) => r.code).join(",");
      }
      if (query.length > 0) {
        url += "?" + query.substring(1);
      }
      url = encodeURI(url);
      history.replaceState({}, "new page", url);
    },
    resizeCruiseList() {
      const cruiseListHeight =
        window.innerHeight -
        this.$refs.searchPackageFilter.offsetHeight -
        this.$refs.searchPackageTags.offsetHeight -
        95 - this.selectHeight;
      this.$refs.searchPackageLists.style.height = cruiseListHeight + "px";
    },
    checkShowScroll() {
      const scrollTop = this.$refs.searchPackageLists.scrollTop;
      if (scrollTop > 300) {
        this.$refs.toScrollTop.style.display = "block";
      } else {
        this.$refs.toScrollTop.style.display = "none";
      }
      this.hideRightBar();
      if (this.scrollEndTimeout) {
        clearTimeout(this.scrollEndTimeout);
      }
      this.scrollEndTimeout = setTimeout(() => {
        this.showRightBar();
      }, 250);
    },
    scrollToTop() {
      this.$refs.searchPackageLists.scroll({ top: 0, behavior: "smooth" });
      gioTracking('track','evt_ButtonClicked', {'btnType':'toTop'})
    },
    showRightBar() {
      this.$refs.priceIcon.style.right = "4px";
      this.$refs.toScrollTop.style.right = "4px";
      this.$refs.ticketIcon.style.right = "4px"
      if (this.$refs.popupIcon) {
        this.$refs.popupIcon.style.right = "4px";
      }
    },
    hideRightBar() {
      this.$refs.priceIcon.style.right = "-20px";
      this.$refs.toScrollTop.style.right = "-20px";
      this.$refs.ticketIcon.style.right = "-20px";
      if (this.$refs.popupIcon) {
        this.$refs.popupIcon.style.right = "-20px";
      }
    },
    cruiseListScrollHandler(e) {
      const target = e.target;
      // if (
      //   target.scrollTop >=
      //   this.$refs.searchListContent.offsetHeight - target.offsetHeight
      // ) {
      //   if (
      //     this.storedCruiseCount > this.cruiseLists.length &&
      //     !this.isLoadingCruise
      //   ) {
      //     this.offset += this.limit;
      //     this.cruiseSearch();
      //   }
      // }
      const scrollTop = target.scrollTop;
      let distanceToBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
      const isScrollingDown = scrollTop > this.lastScrollTop;
      this.lastScrollTop = scrollTop;

      if(distanceToBottom<=50 && isScrollingDown) {
        if (
            this.storedCruiseCount > this.cruiseLists.length &&
            !this.isLoadingCruise
        ) {
          this.offset += this.limit;
          this.cruiseSearch();
        }
      }
    },
    checkPopup() {
      const hasPopup = this.$cookies.get("CRUISE_POPUP");
      if (!hasPopup && this.mobilePopupImage && this.mobilePopupImage.id > 0) {
        this.isShowPopup = true;
        var curDate = new Date();
        var curTamp = curDate.getTime();
        var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
        var passedTamp = curTamp - curWeeHours;
        var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
        var leftTime = new Date();
        leftTime.setTime(leftTamp + curTamp);
        document.cookie =
          "CRUISE_POPUP=1;path=/;expires=" + leftTime.toGMTString();
        this.$store.dispatch("HIDE_HEADER_BAR", {
          isHideHeader: true,
          isHideFooter: true,
        });
      }
    },
    closePopup() {
      this.isShowPopup = false;
      this.$store.dispatch("HIDE_HEADER_BAR", {
        isHideHeader: false,
        isHideFooter: false,
      });
    },
    goPromoPage (link) {
      gioAdsTracking({
        "adsType": "bm",
        "desUrl": link
      })
    },
    showCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = true;
      history.pushState({ page: "detail" }, null);
      gioTracking('track','evt_ButtonClicked', {'btnType':'priceStatement'})
    },
    closeCruisePriceInfo() {
      this.isShowCruisePriceInfoPopup = false;
    },
    showPromoTimeout () {
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			this.checkPromoTimeout = setTimeout(()=> {
				if (!this.userInfo || this.userInfo.userIdentity !== 1) {
					this.showPromoPopup();
				}
			}, promoCountDown)
		},
		showPromoPopup () {
			this.showPromo = 1;
      this.$nextTick(()=>{
        // 右边，位置出现在 20% ~ 55%
        let top = getRandomInt(30, 50);
        this.$nextTick(()=> {
					document.getElementById('wnBabyRight').style.top = top + '%';
          this.showPromoEffect();
				})
      })
		},
    showPromoEffect () {
      if (this.promoEffectInterval) {
        clearInterval(this.promoEffectInterval)
      }
      this.promoEffectInterval = setInterval(()=> {
       let initRight = '-44px';
        let effectRight = '-24px';
        document.getElementById('wnBabyRight').style.right = effectRight;
        setTimeout(()=> {
          document.getElementById('wnBabyRight').style.right = initRight;
        }, randomPromoOff);

      }, randomPromoShow);
    },
    goPromo() {
      location.href = "https://mobile.rcclchina.com.cn/privilege/qibao"
    },
    closeTicketContainsPopup() {
      this.isShowTicketContainsPopup = false;
    },
    showTicketContainsPopup() {
      this.isShowTicketContainsPopup = true;
    },
    async getSearchYouLikeRoute() {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
      let shipCode =  '';
      let sailDate =  '';
      if(recentlyViewed){
        shipCode = recentlyViewed.shipCode;
        sailDate = recentlyViewed.sailDate;
      }
      const { data ,success} = await api.booking.getSearchYouLikeRoute({
        shipCode:shipCode,
        sailDate:sailDate
      });
      if(success===true && data!==null){
        this.likeRoutePopupsList = data.cruises
      }
    },
    onFilterRemove(code,key,name){
      console.log(code,key,name)
      let query = this.selectFilterCodes;
      if(query.sailDates){
        this.filterDeletion(this.selectFilterCodes.sailDates,code,key)
      }
      if(query.sailDays){
        this.filterDeletion(this.selectFilterCodes.sailDays,code,key)
      }
      if(query.departures){
        this.filterDeletion(this.selectFilterCodes.departures,code,key)
      }
      if(query.destinations){
        this.filterDeletion(this.selectFilterCodes.destinations,code,key)
      }
      if(query.shipCodes){
        this.filterDeletion(this.selectFilterCodes.shipCodes,code,key)
      }
      if(query.tags){
        this.filterDeletion(this.selectFilterCodes.tags,code,key)
      }
      if(query.shipCodes){
        this.filterDeletion(this.selectFilterCodes.shipCodes,code,key)
      }
    },
    filterDeletion(arr,code,key){
      arr.forEach((item,index)=>{
        let data = {
          cruiseType: 'hp',
          key: key,
          values: [{ code: code, name: name }]
        }
        if(item.code===code){
          arr.splice(index,1)
          this.selectFilterCodesView = this.initFilterData(this.selectFilterCodes);
          this.selectFilterCodesView = this.selectFilterCodesView.filter(item => item.code !== code)
          this.filterConfirmHandler(this.selectFilterCodesView)
          this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
        }
      })
    },
    bindSearch() {
      // let filterPlp = []
      this.isPackUpIcon = !this.isPackUpIcon
      // if(this.selectFilterCodesView.length>5){
      //   filterPlp = []
      //   this.selectFilterCodesView.forEach((item,idx)=>{
      //     if(idx<=4){
      //       filterPlp.push(item)
      //       this.selectFilterCodesView = filterPlp
      //     }
      //   })
      // }else if(this.selectFilterCodesView.length===5){
      //   filterPlp = []
      //   this.selectFilterCodesView = this.initFilterData(this.selectFilterCodes);
      // }
    },
  //   清空选择
    onResetClick(){
      this.selectHeight = 0
      this.resizeCruiseList();
      this.selectFilterCodesView =this.getDefaultOrderBy()
      this.filterConfirmHandler(this.selectFilterCodesView)
      this.$store.dispatch('INIT_CRUISE_FILTER_LIST', { cruiseType: "hp", data: [] })
      this.emptyCondition = false
    },
    async getCruiseBanner() {
      const requestData = {
        businessType:1
      }
      const {success, data, errMsg} = await api.cruise.getCruiseBannerApi(requestData);
      if (success) {
        this.filterBannerList = data
        // console.log(data)
      } else {
        this.$alert.show(errMsg);
      }
    },
    getDefaultOrderBy() {
      return [{
        key: 'orderBysailDate',
        code: 0,
        name: ''
      }, {
        key: 'orderByPrice',
        code: 0,
        name: ''
      }, {
        key: 'orderBysailDate',
        code: 0,
        name: ''
      }]
    },
    handleFilterBanner(link, index) {
      gioTracking('track', 'evt_ButtonClicked',{
        'btnType': `CruiseSearchBanner${index+1}`
      })
      if(!link) return
      window.location.href = link;
    },
    handleAddVip() {
      gioTracking('track', 'evt_ButtonClicked',{
        'btnType': `CruiseSearchMemberBanner`
      })
      this.$router.push({
        path: `/Rccl.UserCenter/CustomerInfo/SignUpReward`,
      });
    }
  },
  computed: {
    userInfo () {
			return this.$store.state.user.userInfo
		},
    cruiseFilters() {
      return this.$store.state.cruise.cruiseSearchPage.cruiseFilters;
    },
    months() {
      return this.$store.state.cruise.cruiseSearchPage.months;
    },
    tags() {
      let tags = this.$store.state.cruise.cruiseSearchPage.tags;
      if (tags.length > 15) {
        tags = tags.slice(0, 15);
      }
      return tags;
    },
    mobilePopupImage() {
      return this.$store.state.cruise.cruiseSearchPage.mobilePopupImage;
    },
    departures() {
      return this.cruiseFilters.filter(
        (i) => i.category == "DEPARTURE" && i.active
      );
    },
    destinations() {
      return this.cruiseFilters.filter(
        (i) => i.category == "DESTINATION" && i.active
      );
    },
    topSearchs() {
      return this.$store.state.cruise.cruiseSearchPage.tagTopShowList;
    },
    shipCodes() {
      return this.cruiseFilters.filter(
        (i) => i.category == "SHIPS" && i.active
      );
    },
    tagFilters() {
      return this.cruiseFilters.filter((i) => i.category == "TAG" && i.active);
    },
    tagPromoList(){
      return this.$store.state.cruise.cruiseSearchPage.tagPromoList
    },
    themeList(){
      return this.$store.state.cruise.cruiseSearchPage.tagThemeList
    },
    tagHolidayList(){
      return this.$store.state.cruise.cruiseSearchPage.tagHolidayList
    },
    storedCruiseLists() {
      return this.$store.state.cruise.cruiseLists.items;
    },
    storedCruiseCount() {
      return this.$store.state.cruise.cruiseLists.count;
    },
    cruiseCategories() {
      const homePage = this.$store.state.page.homePage;
      if (
          homePage &&
          homePage.recommendCruiseArea &&
          homePage.recommendCruiseArea.promoCruiseCategories
      ) {
        return homePage.recommendCruiseArea.promoCruiseCategories;
      }
      return [];
    },
    promoCruiseItems() {
      const homePage = this.$store.state.page.homePage;
      if (
          homePage &&
          homePage.recommendCruiseArea &&
          homePage.recommendCruiseArea.cruisePromoItems
      ) {
        console.log(homePage.recommendCruiseArea.cruisePromoItems)
        return homePage.recommendCruiseArea.cruisePromoItems;
      }
      return [];
    },
    isOverseaUser() {
      const userInfo = this.$store.state.user.userInfo
      if (!userInfo || !userInfo.callingCode) {
        return false;
      }
      return (
          userInfo != null &&
          userInfo.callingCode != "86" &&
          userInfo.callingCode != "+86"
      );
    },
  },
  watch: {
    cruiseFilters() {
      this.initPage();
    },
    storedCruiseLists(newOne) {
      let cruiseChanged = false;
      newOne.forEach((cruise) => {
        if (
          !this.cruiseLists.some(
            (r) =>
              r.sailDate == cruise.sailDate && r.shipCode == cruise.shipCode
          )
        ) {
          this.cruiseLists.push(cruise);
          cruiseChanged = true;



        }
      });
      if (this.isFirstLoading) {
        this.isFirstLoading = false;
      }
      if (cruiseChanged) this.loadingId++;
      this.isLoadingCruise = false;
      this.$loading.hide();
    },
    topSearchs() {
      this.resizeCruiseList();
    },
    mobilePopupImage() {
      this.checkPopup();
    },
    isPackUpIcon(newOne){
      if(newOne){
        setTimeout(() => {
          this.selectHeight = this.$refs.filterMoreSelect.offsetHeight
          this.resizeCruiseList();
        },10)

      }else{
        setTimeout(() => {
          this.selectHeight = this.$refs.filterMoreSelect.offsetHeight
          this.resizeCruiseList();
        },10)
      }
    },
    selectFilterCodesView(newOne){
      if(newOne){
        if(this.$refs.filterMoreSelect!==undefined){
          setTimeout(() => {
            this.selectHeight = this.$refs.filterMoreSelect.offsetHeight
            this.resizeCruiseList();
          },10)
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.wn-baby-image {
	position: fixed;
	width: 120px;

	z-index: 10;
	cursor: pointer;
	img {
		width: 100%;
	}
}

.wn-baby-right {
	right: -47px;
  top: 50%;
	transition: right 0.2s;
}

.search-package-banner {
  background-color: #FFFFFF;
  & > img {
    width: 100%;
  }
}
</style>


<style >
body {
  line-height: normal;
}

.filter {
  -webkit-filter: blur(2px);
  filter: blur(2px);
}

.searchPackageBox {
  //height: calc(100vh - 50px - 45px);
}
.searchPackage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  //height: 100%;
  background-color: #f6f7f8;
}
/**** 筛选 ****/
.searchPackage-filter {
  width: 100%;
  margin-top: 50px;
}

.searchPackage-filter .filter-container {
  width: 100%;
  overflow: hidden;
  //border-bottom: 1px solid #e5e5e5;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  -o-box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
}

.searchPackage-filter .filter-item {
  text-align: left;
  //height: 30px;
  //line-height: 30px;
  margin: 10px 0;
  float: left;
  background-color: #fff;
  position: relative;
  color: #333;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.searchPackage-filter .filter-item.active{
  color: #4A90E2;
}

.searchPackage-filter .filter-itemTitle {
  font-family: PingFang-SC-Medium;
  font-size: 13px;
  text-align: center;
  display: flex;
  align-items: center;
  vertical-align: middle;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}



.searchPackage-filter .filter-itemTitle img {
  width: 15px;
  height: 12px;
  vertical-align: super;
  margin: 0 2px;
}

.searchPackage-filter .filter-itemArrow {
  //display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  display: flex;
  align-items: center;
}

.searchPackage-filter .filter-itemArrow > img {
  width: 8px;
}

.searchPackage-filter .filter-item:last-child .filter-itemArrow > img {
  width: 12px;
}

.searchPackage-filter
  .filter-item.selected
  .filter-itemArrow
  > img:first-child {
  display: none;
  transform: rotate(180deg);
}

.searchPackage-filter .filter-item.selected .filter-itemArrow > img:last-child {
  display: block;
  transform: rotate(180deg);
}

.searchPackage-filter
  .filter-item:nth-child(4)
  .filter-itemArrow
  > img:first-child {
  display: block;
  transform: rotate(0deg);
}


.searchPackage-filter
  .filter-item:nth-child(4).selected
  .filter-itemArrow
  > img:last-child {
  display: block;
  transform: rotate(0deg);
}

.searchPackage-filter
  .filter-item:nth-child(4).selected
  .filter-itemArrow
  > img:first-child {
  display: none;
  transform: rotate(0deg);
}

.searchPackage-filter
  .filter-item.selected.active
  .filter-itemArrow
  > img:last-child {
  display: block;
  transform: rotate(0deg);
}

.searchPackage-filter .filter-item .filter-itemDot {
  position: absolute;
  right: 30%;
  top: 39%;
  width: 6px;
  text-align: center;
  height: 6px;
  line-height: 6px;
  background-color: #ff5055;
  border-radius: 6px;
  font-size: 10px;
  color: #ffffff;
  font-weight: bold;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  display: none;
}

.searchPackage-filter .filter-item.selected .filter-itemDot {
  display: block;
}

.searchPackage-filter .filter-item:nth-child(2) .filter-itemDot {
  right: 3%;
}

.searchPackage-filter .filter-item:nth-child(4) .filter-itemDot {
  right: -2%;
}

/**** tags ****/
.searchPackage-tags {
  //height: 38px;
  width: 100%;
}

.searchPackage-tags .tags-container {
  padding-bottom: 12px;
  position: relative;
  background-color: #ffffff;
  margin-bottom: 2px;
}

.searchPackage-tags .tags-container .tags-item {
  display: inline-block;
  background: #F1F6FA;
  border-radius: 12.5px;
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #3D8FDB;
  height: 25px;
  line-height: 25px;
  padding: 0 9px;
}
.tagsSwiper .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.searchPackage-tags .tags-container .tags-item.active {
  background: #4C90E1;
  color: #ffffff;
}

.tagsSwiper .swiper-slide {
  width: auto;
  margin-right: 12px;
  height: auto;
}

.tagsSwiper .swiper-slide:first-child {
  margin-left: 18px;
}

.tags-container .swiper-button-prev,
.tags-container .swiper-button-next {
  transform: scale(0.4);
  -webkit-transform: scale(0.4);
  -moz-transform: scale(0.4);
  -ms-transform: scale(0.4);
  -o-transform: scale(0.4);
}

.tags-container .swiper-button-prev {
  width: 54px;
  background-image: none;
  opacity: 1;
  left: -2px;
  display: none;
}

.tags-container .swiper-button-next {
  width: 54px;
  background-image: none;
  right: -18px;
}

.tags-container .swiper-button-prev img,
.tags-container .swiper-button-next img {
  width: 50%;
}

.tags-container .swiper-button-prev img {
  margin-left: -40%;
}

.tags-container .swiper-button-next img {
  margin-right: -40%;
}
/**** 列表 ****/
.searchPackage-lists {
  width: 100%;
  overflow-y: auto;
}

.searchPackage-lists .searchPackage-listsCon {
  width: 100%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.searchPackage-lists .searchPackage-listItem {
  background-color: #ffffff;
  padding: 17px 20px 0 20px;
  position: relative;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}

.searchPackage-lists .listItem-cruiseName {
  font-family: PingFangSC-Semibold;
  font-size: 13px;
  color: #333333;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18.5px;
}

.searchPackage-lists .listItem-cruiseInfo {
  overflow: hidden;
  margin-top: 8px;
  position: relative;
  margin-left: -4.5px;
  padding-left: 4.5px;
  padding-bottom: 16px;
  //border-bottom: 1px solid #f3eeee;
}
.listItem{
  border-bottom: 1px solid #f3eeee;
}
.nearRoute{
  font-size: 11px;
  color: #3D8FDB;
  margin-bottom: 4px;
}
.nearRoutePopup{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.nearRoute-main{
  position: absolute;
  width: 270px;
  height: 146px;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 11px;
}
.near-title{
  color: #FED311;
  font-size: 21px;
  text-align: center;
  line-height: 29px;
}
.near-text{
  color: #000;
  font-size: 13px;
  //text-align: center;
  line-height: 20px;
  padding: 0 22px;
}
.near-btn{
  width: 100%;
  height: 41px;
  background: conic-gradient( from 135deg at 100% 0%, #FFDB17 0%, #FCBF00 100%);
  text-align: center;
  color: #000;
  line-height: 41px;
}
.searchPackage-lists .listItem-cruiseInfo-pic {
  width: 120px;
  height: 150px;
  position: relative;
  float: left;
  overflow: hidden;
}

.searchPackage-lists .listItem-cruiseInfo-pic > img {
  width: 100%;
}

.searchPackage-lists .listItem-cruiseInfo-pic .listItem-cruiseInfo-picTitle {
  width: 100%;
  height: 40.199%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(0, 0, 0, 0)),
    color-stop(92%, rgba(0, 0, 0, 0.64))
  );
  background-image: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.64) 92%
  );
  background-image: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.64) 92%
  );
  background-image: -o-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.64) 92%
  );
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.64) 92%
  );
  font-family: PingFang-SC-Medium;
  font-size: 11px;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
}

.searchPackage-lists
  .listItem-cruiseInfo-pic
  .listItem-cruiseInfo-picTitle
  > span {
  display: inline-block;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 3px;
  transform: scale(0.9);
  -webkit-transform: scale(0.9);
  -moz-transform: scale(0.9);
  -ms-transform: scale(0.9);
  -o-transform: scale(0.9);
}

.searchPackage-lists .listItem-cruiseInfo-tips {
  width: 34px;
  height: 15px;
  line-height: 15px;
  position: absolute;
  top: 7.5px;
  left: 0;
  background: #ff5055;
  font-family: PingFang-SC-Medium;
  font-size: 11px;
  color: #ffffff;
  letter-spacing: 0.785px;
  text-align: center;
}

.searchPackage-lists .listItem-cruiseInfo-tips:after {
  content: "";
  width: 0;
  height: 0;
  border-right: 4.5px solid #d1282d;
  border-bottom: 5px solid transparent;
  position: absolute;
  bottom: -5px;
  left: 0;
}

.searchPackage-lists .listItem-cruiseInfo-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 203px;
  min-height: 150px;
  float: left;
  margin-left: 11px;
  position: relative;
}

.searchPackage-lists .listItem-cruiseInfo-right-box1 {
  /* -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1; */
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -moz-box-orient: vertical;
  -moz-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.searchPackage-lists .listItem-cruiseInfo-right-box2 {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
}

.listItem-cruiseInfo-prompt {
  overflow: hidden;
}

.listItem-cruiseInfo-prompt > div {
  float: left;
  padding: 0 12px;
  border-left: 1px solid #e3e3e3;
}

.listItem-cruiseInfo-prompt > div:first-child {
  padding-left: 0px;
  border-left: none;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptSellOut {
  height: 16px;
  line-height: 16px;
  margin-bottom: 9px;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptSellOut > img {
  width: 13px;
  vertical-align: middle;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptSellOut > span {
  display: inline-block;
  vertical-align: middle;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #ffc021;
  letter-spacing: 0;
  text-align: left;
  margin-left: -3px;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptHot {
  height: 16px;
  line-height: 16px;
  margin-bottom: 9px;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptHot > img {
  width: 13px;
  vertical-align: middle;
  font-size: 0;
}

.listItem-cruiseInfo-prompt .cruiseInfo-promptHot > span {
  display: inline-block;
  vertical-align: middle;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #ff2b2b;
  letter-spacing: 0;
  text-align: left;
  margin-left: -3px;
}

.listItem-cruiseInfo-sailDays {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  height: 19px;
  line-height: 19px;
}

.listItem-cruiseInfo-sailDate {
  padding-top: 2.75px;
  padding-bottom: 11.65px;
  height: 28.4px;
  line-height: 14px;
}

.listItem-cruiseInfo-sailDate > span {
  display: inline-block;
  vertical-align: middle;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
}

.listItem-cruiseInfo-sailDate > img {
  width: 31px;
  vertical-align: top;
  font-size: 0;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 10px;
}

.listItem-cruiseInfo-sailDate i {
  display: inline-block;
  vertical-align: bottom;
  width: 7.5px;
  overflow: hidden;
}

.listItem-cruiseInfo-tags-box {
  /* -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1; */
  max-height: 48px;
}

.listItem-cruiseInfo-tags {
  min-height: 24px;
  max-height: 48px;
  font-size: 0;
  overflow: hidden;
}

.listItem-cruiseInfo-tags.active {
  height: 22px;
}

.listItem-cruiseInfo-tags > span {
  display: inline-block;
  height: 16.5px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding-left: 4.5px;
  padding-right: 5.5px;
  font-family: PingFangSC-Light;
  font-size: 10px;
  line-height: 16.5px;
  color: #4a90e2;
  letter-spacing: 1.43px;
  text-align: center;
  background: rgba(37, 96, 212, 0.05);
  border-radius: 16.37px;
}

.listItem-cruiseInfo-perPrice,
.listItem-cruiseInfo-perNight {
  display: inline-block;
  height: 16.5px;
  line-height: 16.5px;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  margin-top: 4px;
  position: relative;
}

.listItem-cruiseInfo-popularTag {
  background-color: #fbc500;
  padding: 1px 5px;
}

.popular-number {
  color: #ffa70d;
  font-weight: bold;
  margin-left: 5px;
}

.listItem-cruiseInfo-perNight {
  /* margin-top: 4.5px; */
}

.listItem-cruiseInfo-perNight p {
  margin: 0px;
}

.listItem-cruiseInfo-perPrice a {
  color: inherit;
  border-bottom: 1px solid #979797;
}

.listItem-cruiseInfo-perPrice .cruisePrice-per {
  font-family: Arial-BoldMT;
  font-size: 18px;
  font-weight: bold;
  color: #ff0000;
  letter-spacing: 0;
  margin-left: 10px;
}

.listItem-cruiseInfo-perPrice .cruisePrice-per span {
  font-size: 12px;
  margin-right: 5px;
}

.listItem-cruiseInfo-teamPrice {
  width: 208px;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  line-height: 23px;
  color: #666666;
  letter-spacing: 0;
  border: 1px solid rgba(254, 188, 16, 1);
  margin-top: 12.5px;
  padding-left: 5px;
  position: relative;
  left: -4px;
  height: 25px;
}

.listItem-cruiseInfo-teamPrice a {
  color: #666;
}

.listItem-cruiseInfo-teamPrice a > span {
  display: inline-block;
  position: relative;
}

.listItem-cruiseInfo-teamPrice a .cruisePrice-team {
  font-family: Arial-BoldMT;
  font-size: 15px;
  font-weight: bold;
  color: #ff0000;
  letter-spacing: 0;
  margin-left: 2px;
}

.listItem-cruiseInfo-teamPrice a > button {
  height: 25px;
  line-height: 25px;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #454545;
  letter-spacing: 0;
  border: none;
  background-image: -webkit-gradient(
    linear,
    right top,
    left top,
    from(#fad961),
    to(#febc10)
  );
  background-image: -webkit-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: -moz-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: -o-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
  vertical-align: top;
  padding: 0px 8px;
  display: inline-block;
  position: absolute;
  top: -1px;
  right: -1px;
}

.listItem-like {
  position: absolute;
  right: -10px;
  top: 7px;
  text-align: center;
}

.listItem-like > img {
  width: 41px;
  display: none;
  padding: 0 10px 0px 10px;
}

.listItem-like .wish-num {
  font-size: 12px;
  color: #666;
}

.listItem-like > img:first-child {
  display: block;
}

.listItem-like.active > img:first-child {
  display: none;
}

.listItem-like.active > img:nth-child(2) {
  display: block;
}

/**** 筛选内容 ****/
.filter-condition {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 52px;
  left: 0;
  z-index: 11111112;
  background-color: rgba(0, 0, 0, 0.3);
  display: none;
}

.filter-condition .destination-content .product-name {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #333333;
  letter-spacing: 1px;
  margin-bottom: 0;
}

.filter-condition .destination-content {
  //padding-bottom: 15px;
}

.filter-condition .destination-content .product-name .line {
  display: inline-block;
  vertical-align: middle;
  width: 3px;
  height: 14px;
  background: #ffcd00;
}

.filter-condition .destination-content .product-name .text {
  display: inline-block;
  vertical-align: middle;
  margin: 12px 0 5px;
  font-size: 12px;
  color: #666666;
}

.filter-condition .filter-conditionCon {
  width: 100%;
  background-color: #fff;
  //padding-bottom: 60px;
  position: relative;
}

.filter-condition .filter-conditionContainer {
  width: 100%;
  //height: 370px;
  //overflow-y: auto;
  //overflow-x: hidden;
  //padding-bottom: 60px;
}

.filter-condition .filter-conditionContainer > div {
  display: none;
  //padding: 0px 14px;
}

.filter-conditionItem {
  overflow: hidden;
  //margin-bottom: 15px;
  border-bottom: 1px solid #EEEEEE;
}

.destination-container .conditionItem-title {
  border: none;
}

.conditionItem-title {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 1px;
  //padding-bottom: 5px;
  //border-bottom: 1px solid #e5e5e5;
  margin-top: 12px ;
  overflow: hidden;
}
.fontWeight{
  font-size: 14px;
  font-weight: bold;
}
.filter-conditionItem .destination-conditionItem {
  margin-top: 12px;
}

.conditionItem-con {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.departures-con{
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  //justify-content: space-between;
}
.conditionItem-name {
  width: 80px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  float: left;
  background: rgba(229, 229, 229, 0.6);
  margin-bottom: 7px;
  //margin-right: 5px;
  border-radius: 3.64px;
  position: relative;
  //margin-top: 12px;
  //padding: 0 22px;
}

.conditionItem-name:nth-child(3n + 3) {
  //margin-right: 0px;
}

.portItem {
  width: calc(100% / 2 - 10px);
}
.portItem span{
  width: 100px !important;
}
.conditionItem-name.noMarginRight {
  margin-right: 0px;
}

.conditionItem-name span {
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 1.71px;
  padding: 0 10px;
  width: 80px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  box-sizing: border-box;
  white-space: nowrap;
  text-align: center;
}

.conditionItem-name.active {
  background: #4a90e2;
  /* border-radius: 7.28px; */
  opacity: 1;
}

.conditionItem-name.active span {
  color: #ffffff;
}

.conditionItem-name.noactive {
  opacity: 0.2;
  background-color: rgba(204, 204, 204, 0.6);
}

.conditionItem-hotIcon {
  position: absolute;
  top: -16px;
  right: -2px;
}

.conditionItem-hotIcon img {
  width: 27px;
}

.filter-condition .filter-conditionButton {
  width: 100%;
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.conditionItem-resetBtn {
  width: 50%;
  height: 48px;
  line-height: 48px;
  float: left;
  text-align: center;
  background: #ffffff;
  border-top: 1px solid rgba(204, 204, 204, 0.25);
  /*margin-top: 10px;*/
}

.conditionItem-resetBtn > img {
  width: 18px;
  vertical-align: middle;
}

.conditionItem-resetBtn > span {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #999999;
  letter-spacing: 1px;
  display: inline-block;
  vertical-align: middle;
}

.conditionItem-submitBtn {
  width: 50%;
  height: 48px;
  line-height: 48px;
  float: left;
  text-align: center;
  background-color: #ffc021;
  background-image: -webkit-gradient(
    linear,
    right top,
    left top,
    from(#fad961),
    to(#febc10)
  );
  background-image: -webkit-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: -moz-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: -o-linear-gradient(right, #fad961 0%, #febc10 100%);
  background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
  border-top: 1px solid rgba(204, 204, 204, 0.25);
  /*margin-top:10px;*/
}

.conditionItem-submitBtn > img {
  width: 18px;
  vertical-align: middle;
}

.conditionItem-submitBtn > span {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #454545;
  letter-spacing: 1px;
  display: inline-block;
  vertical-align: middle;
}

.filter-conditionCon .filter-sort {
}

.filter-conditionCon .filter-sort > div {
  border-bottom: 1px solid rgba(229, 229, 229, 0.75);
  height: 60px;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 31px 0 17px;
  justify-content: space-between;
}
.filter-conditionCon .filter-sort > div  span {
  display: inline-block;
  /*width: 155px;*/
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  width: 87px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.86px;
  vertical-align: middle;
  border-radius: 4px;
}
.filter-conditionCon .filter-sort > .active  span {
  display: inline-block;
  /*width: 155px;*/
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #fff;
  width: 87px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.86px;
  vertical-align: middle;
  background-color: #4C90E1;
  border-radius: 4px;
}

.filter-conditionCon .filter-sort > div img {
  //position: relative;
  z-index: 5;
  width: 21px;
  height: 24px;
  vertical-align: middle;
  margin-left: 11px;
  //display: none;
}

.filter-conditionCon .filter-sort > div.active img {
  display: inline-block;
}

.filter-moreSelect {
  padding: 11px 11px 0 20px;
  background: #f6f7f8;
  display: none;
}

.filter-moreSelect > span {
  font-family: PingFang-SC-Regular;
  font-size: 12px;
  color: #999999;
  letter-spacing: 1.43px;
  display: inline-block;
  vertical-align: top;
  margin-top: 3px;
}

.filter-selectedItem {
  display: inline-block;
  overflow: hidden;
  width: 298px;
  max-height: 90px;
  overflow: scroll;
}

.filter-selectedItem > div {
  float: left;
  padding: 0px 8px;
  opacity: 0.99;
  background: #ffffff;
  border-radius: 17px;
  border-radius: 17px;
  margin-right: 9px;
  margin-bottom: 6px;
}

.filter-selectedItem > div > span:first-child {
  font-family: PingFangSC-Light;
  font-size: 12px;
  color: #333333;
  letter-spacing: 1.43px;
}

.filter-selectedItem > div > span:last-child {
  padding-left: 7px;
  display: inline-block;
  transform: scaleX(1.3);
  -webkit-transform: scaleX(1.3);
  -moz-transform: scaleX(1.3);
  -ms-transform: scaleX(1.3);
  -o-transform: scaleX(1.3);
}

.conditionItem-area {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #333333;
  letter-spacing: 1px;
  margin-bottom: 0;
}

.conditionItem-arrow > span {
  display: inline-block;
  float: right;
  /* margin-top: 8px; */
}

.conditionItem-arrow span.item-arrow {
  display: none;
  color: #666;
  font-size: 12px;
}
.conditionItem-arrow span.item-arrow img {
  width: 14px;
}

.conditionItem-arrow span.item-to-open img {
  transform: rotate(90deg);
}

.conditionItem-arrow span.item-arrow:first-child {
  display: block;
}

.filter-conditionItem.open .conditionItem-arrow span.item-arrow:first-child,
.destination-conditionItem.open
  .conditionItem-arrow
  span.item-arrow:first-child {
  display: none;
}

.filter-conditionItem.open .conditionItem-arrow span.item-arrow:last-child,
.destination-conditionItem.open
  .conditionItem-arrow
  span.item-arrow:last-child {
  display: block;
}

.filter-conditionItem .filter-conditionItem-container {
  display: none;
}
.filterMoreDate{
  display: flex!important;
  flex-direction: column;
  padding-right: 15px!important;
}
.filterMoreDate .yearBox{
  display: flex;
  background-color: #fff!important;
  border-bottom: 1px solid #DDDDDD;
  margin-bottom: 10px;
  padding: 0 14px;
  justify-content: space-evenly;
}
.filterMoreDate .yearBox .item{
  height: 22px !important;
  width: 45px !important;
}
.filterMoreDate .yearBox .item.checked{
  border-bottom: 2px solid #4C90E1;
}
.filterMoreDate .monthBox{
  padding: 0!important;
  margin-bottom: 12px;
}
.filter-conditionItem.open .filter-conditionItem-container,
.destination-conditionItem.open .filter-conditionItem-container {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.filter-timeYear {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 375px;
  margin-top: 2px;
  margin-bottom: 5px;
  margin-left: -20px;
  overflow: hidden;
}

.filter-yearNum {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -moz-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-family: PingFang-SC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 1.14px;
  text-align: center;
}

.filter-arrowLeft,
.filter-arrowRight {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  -moz-box-flex: 0;
  -ms-flex: none;
  flex: none;
  padding: 18px 20px;
}

.filter-arrowLeft img,
.filter-arrowRight img {
  width: 12px;
}

.filter-arrowLeft.noactive,
.filter-arrowRight.noactive {
  filter: alpha(opacity=30); /* IE */
  -moz-opacity: 0.3; /* 老版Mozilla */
  -khtml-opacity: 0.3; /* 老版Safari */
  opacity: 0.3; /* 支持opacity的浏览器*/
}

.filter-timeMonth {
  overflow: hidden;
}

.filter-timeMonth > div {
  width: 71px;
  text-align: center;
  height: 35px;
  line-height: 35px;
  float: left;
  font-family: PingFang-SC-Medium;
  font-size: 12px;
  color: #666666;
  letter-spacing: 1.71px;
  text-align: center;
  background: rgba(229, 229, 229, 0.6);
  border-radius: 3.64px;
  margin-right: 16px;
  margin-bottom: 14px;
}

.filter-timeMonth > div:nth-child(4n + 4) {
  margin-right: 0;
}

.filter-timeMonth > div.noactive {
  opacity: 0.2;
  background: rgba(204, 204, 204, 0.6);
}

.filter-timeMonth > div.selected {
  color: #ffffff;
  background: #4a90e2;
}

.searchPackage-priceIcon {
  position: fixed;
  bottom: 200px;
  right: 4px;
  width: 32px;
  height: 32px;
  padding-top: 4px;
  opacity: 0.8;
  background: #4a90e2;
  z-index: 1000;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  font-size: 10px;
  color: #fff;
  line-height: 12px;
  text-align: center;
}
.searchPackage-priceIcon.js-ticketTips {
  bottom: 237px;
  background: #febc10;
}

.searchPackage-priceIcon img {
  width: 10px;
  margin-top: 8px;
}

.searchPackage-scrollTop {
  position: fixed;
  bottom: 163px;
  right: 4px;
  width: 32px;
  text-align: center;
  height: 32px;
  opacity: 0.8;
  background: #4a90e2;
  z-index: 1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  display: none;
}

.searchPackage-scrollTop.active {
  display: block;
}

.searchPackage-scrollTop img {
  width: 13px;
  margin-top: 8px;
}

/**** 查看价格说明****/
.cruisePrice_intro_content {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  z-index: 11111;
  height: 100%;
  width: 100%;
  display: none;
}

.cruisePrice_intro_content .intro_content {
  width: 93.6%;
  overflow-y: auto;
  left: 3.2%;
  position: relative;
  top: 66px;
  background-color: #fff;
  color: #000;
  padding-bottom: 25px;
}

.cruisePrice_intro_content .close {
  position: absolute;
  right: 12px;
  top: 20%;
}

.cruisePrice_intro_content .close .f7-icons {
  font-size: 21px;
  color: #2c3466;
  padding: 3px;
}

.cruisePrice_intro_content .intro_content {
  padding: 20px 20px 10px 20px;
  height: 52%;
  top: 20%;
}

.cruisePrice_intro_content .cruisePrice_txt {
  font-size: 13px;
  color: #000;
  margin-bottom: 20px;
}

.cruisePrice_intro_content .cruisePrice_txt p {
  font-size: 12px;
  margin-bottom: 2px;
  margin-top: 2px;
}

/* tips */
.cruise-search-tips {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 50001;
  display: none;
}

.cruise-search-tips .step {
  position: relative;
  width: 100%;
  height: 100%;
}

.cruise-search-tips .cruise-search-tips-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(21, 22, 29, 0.7);
}

.cruise-search-tips .tips-content p {
  margin: 2px 0px;
}

.cruise-search-tips .tips-content-next {
  width: 100px;
  margin: 20px auto 0 auto;
}

.cruise-search-tips .tips-content-next img {
  width: 100%;
}

.cruise-search-tips .tip-content-skip {
  text-decoration: underline;
  margin-top: 12px;
}

.cruise-search-tips .tips-content {
  position: absolute;
  color: white;
  font-size: 15px;
  text-align: center;
}

.cruise-search-tips .step-1 .step1_filter {
  position: relative;
  width: 96.8%;
  left: 1.6%;
  top: 50px;
}

.cruise-search-tips .step-1 .tips-content {
  width: 66.4%;
  left: 16.8%;
  top: 130px;
}

.cruise-search-tips .step-2 .step2_wishlist {
  position: absolute;
  width: 38px;
  right: 14px;
  top: 176px;
}

.cruise-search-tips .step-2 .tips-content {
  right: 30px;
  top: 231.5px;
}

.cruise-search-tips .step-3 .step3_calendar {
  position: absolute;
  width: 38px;
  right: 62px;
  top: 218px;
}

.cruise-search-tips .step-3 .tips-content {
  right: 57px;
  top: 267.5px;
}

.cruise-search-tips .step-4 .step4_group {
  position: absolute;
  width: 238px;
  right: 15px;
  top: 303px;
}

.cruise-search-tips .step-4 .tips-content {
  right: 41px;
  top: 355.5px;
}

.no-more-text {
  font-size: 13px;
  color: #333;
}

.popup-priceTips {
  background-color: #f6f7f8;
}

.shorexDetail-title {
  padding: 15px 20px;
  background-color: #fff;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;
  position: fixed;
  width: 100%;
  z-index: 10;
}

.shorexDetail-title > p {
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #333333;
  letter-spacing: 1px;
  text-align: center;
  margin: 0;
}

.shorexDetail-title > div {
  position: absolute;
  top: 16px;
}

.shorexDetail-title > div > img {
  width: 10px;
}

.shorexDetail-returnButton {
  width: 30px;
  position: absolute;
  top: 15px;
  left: 20px;
  text-align: left;
}

.shorexDetail-returnButton > img {
  width: 33%;
}

.ruleDetail {
  margin-top: 60px;
  height: 100%;
  overflow: scroll;
  padding-bottom: 60px;
}

.rule-item {
  margin-bottom: 10px;
  padding: 0 20px 12px;
  font-size: 12px;
  line-height: 20px;
  color: #666;
  letter-spacing: 0;
  background-color: #fff;
}

.rule-item:last-child {
  margin-bottom: 0;
}

.rule-item .rule-item-title {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 17px 0 7px;
  font-size: 14px;
  line-height: 20px;
  color: #4a90e2;
  font-weight: bold;
}

.rule-item-title-line {
  width: 3px;
  height: 12px;
  margin-right: 6px;
  background-color: #4a90e2;
}

.rule-item .rule-item-text p {
  margin: 0px;
}

.rule-item .rule-item-text2 p {
  margin-bottom: 0px;
}

.rule-item-text-title {
  color: #333;
  font-weight: bold;
}

.rule-item .rule-item-text2 .rule-item-text-title {
  margin-bottom: 0;
}

.rule-item-link {
  color: #4a90e2;
  text-decoration: underline;
}

.rule-item .rule-item-text .rule-item-text-title:not(:first-child) {
  margin-top: 10px;
}

.popup {
  -webkit-transform: translate3d(100%, 0, 0);
  -moz-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  height: 100%;
  overflow: hidden;
}

.popup.modal-out {
  -webkit-transform: translate3d(100%, 0, 0);
  -moz-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.searchPackage-tags .tags-container .isHighShow {
  background-color: #febc10 !important;
  color: #fff !important;
}

.js-rightBarBtn {
  transition: 0.2s all;
}

@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (-moz-min-device-pixel-ratio: 2),
  only screen and (-o-min-device-pixel-ratio: 2),
  only screen and (min-device-pixel-ratio: 2) {
}

.item-refund {
  position: absolute;
  top: 16px;
  right: 18px;
}

.item-refund img {
  width: 100px;
}

.promo-popuop {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100000;
}

.promo-popuop .promo-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.promo-popuop .promo-popup-close {
  position: absolute;
  width: 40px;
  top: 40px;
  right: 20px;
}

.promo-popuop img {
  width: 100%;
}

.promo-popup-content {
  position: absolute;
  width: 100%;
  top: 90px;
  left: 0px;
}

.cruiseFixCon-promoBtn {
  position: fixed;
  bottom: 150px;
  bottom: 98px;
  right: 8px;
  width: 37px;
  text-align: center;
  margin: auto;
}

.cruiseFixCon-promoBtn img {
  width: 100%;
}

/*出发时间*/
.searchPackage-lists.isSailDates {
  display: grid;
  height: 400px !important;
}
.filter-condition .filter-conditionCon.isSailDates {
  padding-bottom: 0 !important;
}
.filter-condition .filter-conditionCon.isSailDates .filter-conditionContainer {
  height: auto !important;
  padding-bottom: 0 !important;
}
</style>
<style lang="less">
.filterMoreSelectBox {
  padding: 6px 20px 10px 12px;
  background: #FFFFFF;
  //display: none;
  overflow: hidden;
  font-size: 12px;
  position: relative;
  & .label {
    float: left;
  }
  & .content {
    //max-height: 15px;
    //overflow-x: hidden;
    //overflow-y: auto;
    display: flex;
    flex-flow: wrap;
    gap:7px 10px;
    //padding-right: 15px;
    position: relative;
  }
  & .contentItem {
    display: flex;
    align-items: center;
    box-sizing: border-box !important;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
    border-radius: 12px;
    gap: 4px;
    border: 1px solid #EEEEEE;
    & .text {
      font-size: 12px;
      transform: scale(0.9);
      display: flex;
      .text-icon{
        display: flex;
        align-items: center;
      }
      .text-icon img{
        display: inline-block;
        width: 13px;
        height: 13px;
      }
    }
    & .icon {
      height: 10px;
      width: 10px;
    }
  }
  .emptyCondition{
    border:none;
    color: #00619B;
  }
  .emptyCondition .text{
    border-bottom: 1px solid #00619B;
    line-height: 14px;
  }
  & .contentShowAll{
    //max-height: 90px;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-flow: wrap;
    gap: 5px;
    position: relative;
    padding-right: 30px;
  }
  & .downward {
    width: 20px;
    height: 19px;
    position: absolute;
    top: 5px;
    right: 9px;
    //background-color: red;
    border-left: 1px solid #f7f7f7;
    img{
      width: 8px;
      height: 7px;
      margin-left: 10px;
    }
  }
}
.filterBanner{
  width: 100%;
  box-sizing: border-box;
  background-color: #f7f7f7;
  padding-top: 8px;
  & .swiper-slide{
    padding: 0 10px;
  }
  & a{
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    display: inline-block;
    border-radius: 5px;
    overflow: hidden;
  }
  & img{
    height: 80px;
    width: 100%;
  }
  & .swiper-pagination{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .swiper-pagination .swiper-pagination-bullet{
    background-color: #fff;
    opacity: 1;
  }
  & .swiper-pagination .swiper-pagination-bullet-active{
    width: 10px;
    height: 10px;
    border: 3px solid #fff;
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.initiation {
  width: 100%;
  height: 52px;
  & img{
    width: 100%;
    height: 100%;
  }
}

.listItem-cruiseInfo .salesCountdownBar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 4px;
  position: absolute;
  top: 0;
  left: 6px;
  z-index: 1;
  width: 108px;
  height: 19px;
  background-image: url('https://resource.rcclchina.com.cn/wechatMiniProgram/shipRoutesList/salesCountdownTitleBg.png');
  background-size: 100% 100%;
}
.listItem-cruiseInfo .salesCountdownBar span {
  font-weight: bold;
  display: flex;
  justify-content: center;
  font-size: 12px;
  height: 13px;
  line-height: 13px;
  width: 11px;
  border-radius: 2px;
  background-color: #fff;
  color: #FA531F;
}
.listItem-cruiseInfo .salesCountdownBar div {
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  color: #fff;
}
</style>
